import { MessageProtocol } from '@src/slide/infrastructure/module/independent/windows-message-protocol';
import { callable } from '@tencent/tiny-ioc';
import { ClientVarsService } from '../../../core/services/client-vars-service';
import { SlideInitialDataService } from '../../../core/services/slide-initial-data-service';
import { SlideDataServices } from '../../../core/slide-data-services.core';
import { SubsidiaryDataSlideAppService } from '../services/slide-app-service.subsidiary';
import { MainWindowDataProviderService } from '../../../core/services/main-window-data-provider-service';
import { OnlineDocInfoManager } from '../../online/managers/online-doc-info-manager';

export function registerSubsidiarySlideDataServices() {
    const DataProvider = MessageProtocol.getInstance().createServiceProxy(
        window.opener,
        MainWindowDataProviderService,
    );

    SlideDataServices.ClientVarsService.register(async () => {
        const clientVars = await DataProvider.getClientVars();
        window.clientVars = clientVars;
        return new ClientVarsService(clientVars);
    });

    SlideDataServices.SlideInitialDataService.register(async () => {
        const initialData = await DataProvider.getSlideInitialData();
        return new SlideInitialDataService(initialData);
    });

    SlideDataServices.SlideAppService.register(callable(SubsidiaryDataSlideAppService));
    SlideDataServices.DocInfoManager.register(callable(OnlineDocInfoManager));
}
